// setInterval that skips ticks while the tab is hidden and refreshes on return.
export function visibleInterval(fn, ms) {
  const id = setInterval(() => { if (!document.hidden) fn(); }, ms);
  const onVis = () => { if (!document.hidden) fn(); };
  document.addEventListener('visibilitychange', onVis);
  return () => { clearInterval(id); document.removeEventListener('visibilitychange', onVis); };
}
